/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED STORY PROPERTIES : STYLES --------------- ++++++++++ */
export default theme => ({
    storyproperties: {
        '& .note': {
            marginBottom: pxToEm(6)
        },
        '& .storyurl': {
            transition: 'filter 1s, opacity 1s',
            marginBottom: pxToEm(24),
            '& .formelement, .icon': {
                height: pxToEm(32)
            },
            '& .errormessage': {
                whiteSpace: 'pre-line'
            }
        },
        '& .autopopulateToggle': {
            display: 'flex',
            marginBottom: pxToEm(10),
            '& p': {
                display: 'flex',
                extend: theme.typography.size.xxsmall
            },
            '& .toggle': {
                marginLeft: pxToEm(20),
                fontSize: '50%'
            }
        },
        '&.validurl-false':{
            '& .errormessage':{
                fontSize: `${pxToEm(10)} !important`,
                position: 'absolute'
            }
        }
    },
    [mediaQuery.customizeRailThin]: {
        storyproperties: {
            '& .errormessage': {
                display: 'flex',
                fontSize: pxToEm(10),
            },
            '& .autopopulateToggle': {
                display: 'block',
                '& .toggle': {
                    margin: `${pxToEm(5)} 0`,
                }
            }
        }
    },
    [mediaQuery.customizeInContentThin]: {
        storyproperties: {
            '&.incontent': {
                extend: {
                    '& .errormessage': {
                        display: 'flex',
                        fontSize: pxToEm(10),
                    },
                    '& .autopopulateToggle': {
                        display: 'block',
                        '& .toggle': {
                            margin: `${pxToEm(5)} 0`,
                        }
                    }
                }
            }
        }
    },
    [mediaQuery.customizeThinnest]: {
        storyproperties: {
            '& .field': {
                display: 'inline',
            }
        }
    }
});
